module.exports = __webpack_public_path__ + "static/media/1012620.f236a1bf.jpg";